<div class="referral-home-banner">
  <img
    [src]="REFERRAL_ENVELOPE_IMAGE"
    alt=""
    width="96"
    height="96"
    class="referral-home-banner__art"
  />

  <div class="referral-home-banner__text flex-1">
    <h2 class="semi-bold">
      Invite friends. Earn up to {{ program.rewardAmount | portalCurrency: true }} each
    </h2>
    <p class="mt-1">
      They get {{ program.rewardAmount | portalCurrency: true }} in travel credit. You earn up to
      {{ program.rewardAmount | portalCurrency: true }} after they complete their journey.
    </p>
  </div>

  <ds-button
    [routerLink]="['/', PortalRoutes.Referrals]"
    label="Read more"
    class="referral-home-banner__cta d-none d-md-inline"
    data-id="referral-home-read-more"
  />
  <ds-button
    [routerLink]="['/', PortalRoutes.Referrals]"
    label="Read more"
    [fullWidth]="true"
    class="referral-home-banner__cta d-md-none mt-3"
    data-id="referral-home-read-more-mobile"
  />
</div>
